angular.module('app').filter('cpfCnpj', function () {
  return function (item) {
    if (item.length <= 11) { return item.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4') } else { return item.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5') }
  }
})



//////////////////
// WEBPACK FOOTER
// ./filters/cpfCnpj.filter.js
// module id = 96
// module chunks = 0